import React from 'react';
import './technologyCard.css';

const TechnologyCard = ({ technology }) => {
  return (
    <>
      <a
        href={technology.url}
        target="_blank"
        rel="noreferrer"
        className="technologyCardContainer"
      >
        <img
          src={technology.logo}
          alt={technology.name}
          className="technologyCardImage"
        />
        <h2 className="technologyCardName">{technology.name}</h2>
      </a>
    </>
  );
};

export default TechnologyCard;
